import "./evenement.scss";
import "../../assets/scripts/isotope_init.js";
import $ from 'jquery';

// ISOTOPE
var $grid_evenement = $('.grid_evenement');
if($grid_evenement.length != 0) {
    $grid_evenement.isotope({
        itemSelector: '.evenement',
        layoutMode: 'vertical',
        filter: '.futur'
    });
    if (!$grid_evenement.data('isotope').filteredItems.length) {
        $('.noResult').show();
    } else {
        $('.noResult').hide();
    }

    // FILTRE
    var passe_futur = 'futur';
    var type = '';
    $('select[name="passe_futur"]').change(function () {
        if (passe_futur == 'futur') {
            passe_futur = 'passe';
        } else {
            passe_futur = 'futur';
        }
        $grid_evenement.isotope({filter: type + '.' + passe_futur});
        if (!$grid_evenement.data('isotope').filteredItems.length) {
            $('.noResult').show();
        } else {
            $('.noResult').hide();
        }
    });

    $('select[name="type"]').change(function () {
        if($(this).val() == 'tous'){
            type = '';
        } else {
            type = '.'+$(this).val();
        }
        $grid_evenement.isotope({filter: type + '.' + passe_futur});
        if (!$grid_evenement.data('isotope').filteredItems.length) {
            $('.noResult').show();
        } else {
            $('.noResult').hide();
        }
    });
}

